// @flow
import React, { useState, useEffect } from 'react';

// Our hook
export function useDebounce(values: $ReadOnlyArray<*>, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(values);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(values);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, values);

  return debouncedValue;
}
